import { useCallback, useEffect, useState } from "react";
import api from "../lib/api";

// Le référentiel des types de mandat (« Gérant » et ceux que l'administrateur ajoute).
export default function useMandateTypes() {
  const [types, setTypes] = useState([]);
  const [status, setStatus] = useState("loading"); // loading | ready | error

  const reload = useCallback(async () => {
    try {
      const { data } = await api.get("/collaborators/mandate-types");
      setTypes(data.items);
      setStatus("ready");
    } catch (e) {
      setStatus("error");
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  return { types, status, reload };
}
